module.exports = __webpack_public_path__ + "img/Aio-Dark-Transparent-Marque-Vector.2dd07e30.svg";